import ReactDOM from 'react-dom';
import React from 'react';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ThemeProvider from "./services/providers/theme-provider";
import AuthProvider from "./services/providers/auth-provider";
import {BrowserRouter} from "react-router-dom";
import ModeProvider from "./services/providers/apimode-provider";
import NotificationProvider from "./services/providers/notification-provider";
import { NotificationToast } from "./components/notifications";

ReactDOM.render(
  <BrowserRouter>
    <ThemeProvider>
      <AuthProvider>
        <NotificationProvider>
          <ModeProvider>
            <App/>
            <NotificationToast />
          </ModeProvider>
        </NotificationProvider>
      </AuthProvider>
    </ThemeProvider>
  </BrowserRouter>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
